import { createAction, props } from '@ngrx/store';

import { ItemsPagination, StatusData } from 'src/app/model/api/data-rest';
import { PaginationParams } from 'src/app/model/api/pagination-params';
import { Task, TaskState, TaskType } from 'src/app/model/tasks';



export const getTasks = createAction('GET_TASKS', props<{
    paging?: PaginationParams; running?: boolean; userId?: number;
}>());
export const getTasksSuccess = createAction('GET_TASKS_SUCCESS', props<{
    paginationParams: PaginationParams; paging: ItemsPagination; tasks: Task[];
}>());
export const getTasksFailed = createAction('GET_TASKS_FAILED', props<{ errorMessage: string }>());

export const getTaskStates = createAction('GET_TASK_STATES');
export const getTaskStatesSuccess = createAction('GET_TASK_STATES_SUCCESS', props<{ states: TaskState[] }>());
export const getTaskStatesFailed = createAction('GET_TASK_STATES_FAILED', props<{ errorMessage: string }>());

export const getTaskTypes = createAction('GET_TASK_TYPES');
export const getTaskTypesSuccess = createAction('GET_TASK_TYPES_SUCCESS', props<{ types: TaskType[] }>());
export const getTaskTypesFailed = createAction('GET_TASK_TYPES_FAILED', props<{ errorMessage: string }>());

export const abortTask = createAction('ABORT_TASK', props<{ taskId: number }>());
export const abortTaskSuccess = createAction('ABORT_TASK_SUCCESS', props<{ message: string }>());
export const abortTaskFailed = createAction('ABORT_TASK_FAILED', props<{ errorMessage: string }>());

export const resetActiveTasks = createAction('RESET_ACTIVE_TASKS');
export const getActiveTasks = createAction('GET_ACTIVE_TASKS', props<{
    paging?: PaginationParams; running?: boolean; userId?: number;
}>());
export const getActiveTasksSuccess = createAction('GET_ACTIVE_TASKS_SUCCESS', props<{
    tasks: Task[];
}>());
export const getActiveTasksFailed = createAction('GET_ACTIVE_TASKS_FAILED', props<{ errorMessage: string }>());



export const getServiceStatus = createAction('GET_SERVICE_STATUS');
export const getServiceStatusSuccess = createAction('GET_SERVICE_STATUS_SUCCESS', props<{ statusData: StatusData }>());
export const getServiceStatusFailed = createAction('GET_SERVICE_STATUS_FAILED', props<{ errorMessage: string }>());